<form #f="ngForm" [formGroup]="form">
  <div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
    <h2 class="headline m-0" fxFlex="auto">KumoAgent Settings</h2>

    <button class="text-secondary" (click)="close()" mat-icon-button type="button">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-divider class="-mx-6 text-border"></mat-divider>

  <mat-dialog-content fxLayout="column">

<mat-slide-toggle 
  class="mt-4" 
  color="primary"
  [checked]="toggleMode === 'Co-Pilot Mode'"
  (change)="onToggleChange($event)">
  {{ toggleMode }}
</mat-slide-toggle>

    <vex-single-selection style="width: 100%;"
    #modelSelection
    class="mt-4"
    [data] ="usersAttribute"
    [form] ="form"
    [selectionValues]="models"
    (convertDataUrl)="getModels()"
    >
    </vex-single-selection>

  <mat-form-field class=" flex-auto">
    <mat-label>KumoAgent Role <span class="validation-red-color">*</span></mat-label>
    <textarea type="text" formControlName="KumoBotRole" matInput class="text-area-input"
    rows="4" cdkTextareaAutosize
    cdkAutosizeMinRows="3"
    cdkAutosizeMaxRows="6"></textarea>
    <mat-error class="validation-red-color" *ngIf="inputState(form, f, 'Role')">
      Role is <strong>required</strong>
    </mat-error>
  </mat-form-field>


    <mat-form-field class="flex-auto">
      <mat-label>Specific Instructions <span class="validation-red-color">*</span></mat-label>
      <textarea type="text" formControlName="SpecificInstructions" matInput class="text-area-input"
      rows="4" cdkTextareaAutosize
      cdkAutosizeMinRows="3"
      cdkAutosizeMaxRows="6"></textarea>
      <mat-error class="validation-red-color" *ngIf="inputState(form, f, 'Instructions')">
        Instructions is <strong>required</strong>
      </mat-error>
    </mat-form-field>

  </mat-dialog-content>
  <mat-divider class="-mx-6 text-border"></mat-divider>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()" type="button">CANCEL</button>
    <button  color="primary" mat-raised-button (click)="save()" [disabled]="disabledSaveButton">
      Save
      <mat-icon *ngIf="disabledSaveButton">
        <mat-spinner color="accent" diameter="20"></mat-spinner>
      </mat-icon>
    </button>
   
  </mat-dialog-actions>
</form>